import { Modal, ModalBody } from 'reactstrap'
import { useState, useEffect } from 'react'
import LoadingAbsolute from '../../LoadingAbsolute'

const PayModal = ({ isVisible, onClose, message }) => {
  const [loading, setLoading] = useState(true)

  const endLoaded = () => {
    setLoading(false)
  }

  useEffect(() => {
    const messageHandler = (evt) => {
      setLoading(true)
    }

    window.addEventListener('message', messageHandler)

    // Cleanup function
    return () => {
      window.removeEventListener('message', messageHandler)
    }
  }, [])

  return (
    <Modal centered isOpen={isVisible} toggle={onClose} fullscreen>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <ModalBody
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          lineHeight: 1,
        }}
      >
        <div style={{ marginBottom: '1rem', marginTop: '0.5rem', height: '60%', width: '100%' }}>
          <iframe onLoad={endLoaded} title='pay' frameBorder='0' src={'data:text/html,' + encodeURIComponent(message)} scrolling='yes' style={{ overflow: 'auto', webkitOverflowScrolling: 'touch', height: '100%', width: '100%' }}></iframe>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default PayModal
